(window as any).global = window;
import React, { useState, useEffect } from 'react';
import styles from './styles.module.css'
import { AppManagerTopBar } from './topbar'
import cognitoUtils from "./lib/cognitoUtils"
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export interface Config {
  region: String
  userPool: String
  userPoolBaseUri: String
  clientId: String
  callbackUri: String
  signoutUri: String
  tokenScopes: Array<String>
  appsConfigUrl: String
}

interface Props {
  config: Config
  children?: React.ReactNode,
  Element?: any
}

export const CognitoUtils = cognitoUtils;
export const userSession$ = new BehaviorSubject(null);

export const AppManager = (props: Props) => {
  const callbackCode = new URLSearchParams(document.location.search).get('code');
  const logout = new URLSearchParams(document.location.search).get('logout');
  const [user, setUser] = useState()

  useEffect(() => {
    if(logout) {
      document.location.href = cognitoUtils.getCognitoSignInUri(props.config);
      localStorage.clear();
      return;
    }
    if(callbackCode === null) {
      cognitoUtils.getCognitoSession(props.config).then((response: any) => {
        localStorage.setItem('session', JSON.stringify(response) );
        setUser(response.user)
        userSession$.next(response.user)
      }).catch(err => {
        console.log(err);
        document.location.href = cognitoUtils.getCognitoAuthorizeUri(props.config);
      })
    } else {
      cognitoUtils.parseCognitoWebResponse(props.config, window.location.href) 
      .then(() => cognitoUtils.getCognitoSession(props.config))
      .then((session: any) => {
        localStorage.setItem('session', JSON.stringify(session) );
        setUser(session.user)
        userSession$.next(session.user)
        const url = new URL(document.location.href);
        document.location.href = url.origin + url.pathname;
      })
    }
  }, [])

  // if(user) {
  //   console.log(user!['cognito:groups'])
  // }
  return (
    <div className={styles.app__manager}>
        {user !== undefined ? 
            <AppManagerTopBar {...props} {...user} />
        : null}
    </div>
  )
}
